var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("OOPS! You don't have access to view this page!")]),_c('router-link',{staticClass:"text-info",attrs:{"to":"/applications"}},[_vm._v(" Let us take you to one of our places! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }